import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseRentalAdaptationTemplates = [
  {
    id: '-123001',
    language: Language.EN,
    subject: 'Rental adaptation',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_RENTAL_ADAPTATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>The rental price of the lease located at <strong>{{getLeaseMainAddress lease}}</strong> will be adapted from <strong>{{formatDate leasePriceHistory.applicationDate}}</strong>.</p>
        <p>We are changing your total {{getLeasePaymentFrequency lease}} price from {{getTotalPreviousPriceForFrequency lease leasePriceHistory}} € to <strong>{{getTotalFuturePriceForFrequency lease leasePriceHistory}}</strong> €.</p>
        <p></p>
        {{#if (hasComment leasePriceHistory)}}
        <p>Comment:</p>
        <i>{{leasePriceHistory.comment}}</i>
        <p></p>
        {{/if}}
        <p>Thank you for taking this into account and to adjust the periodical amount of your direct debit.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-123002',
    language: Language.FR,
    subject: 'Adaptation du loyer',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_RENTAL_ADAPTATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Le loyer du bail sis <strong>{{getLeaseMainAddress lease}}</strong> sera adapté à partir du <strong>{{formatDate leasePriceHistory.applicationDate}}</strong>.</p>
        <p>Nous faisons passer votre loyer {{getLeasePaymentFrequency lease}} total de {{getTotalPreviousPriceForFrequency lease leasePriceHistory}} € à <strong>{{getTotalFuturePriceForFrequency lease leasePriceHistory}}</strong> €.</p>
        <p></p>
        {{#if (hasComment leasePriceHistory)}}
        <p>Commentaire:</p>
        <i>{{leasePriceHistory.comment}}</i>
        <p></p>
        {{/if}}
        <p>Merci de bien vouloir prendre ces détails en considération et d'ajuster votre domiciliation périodique.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-123003',
    language: Language.NL,
    subject: 'Huurprijsaanpassingen',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_RENTAL_ADAPTATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>De huurprijs van het huurcontract gelegen op <strong>{{getLeaseMainAddress lease}}</strong> zal worden aangepast vanaf <strong>{{formatDate leasePriceHistory.applicationDate}}</strong>.</p>
        <p>We veranderen uw totale {{getLeasePaymentFrequency lease}} prijs van {{getTotalPreviousPriceForFrequency lease leasePriceHistory}} € naar <strong>{{getTotalFuturePriceForFrequency lease leasePriceHistory}}</strong> €.</p>
        <p></p>
        {{#if (hasComment leasePriceHistory)}}
        <p>Opmerking:</p>
        <i>{{leasePriceHistory.comment}}</i>
        <p></p>
        {{/if}}
        <p>Dank u om hiermee rekening te houden en het periodieke bedrag van uw domiciliëring aan te passen.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-123004',
    language: Language.DE,
    subject: 'Mietanpassung',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_RENTAL_ADAPTATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Der Mietpreis des Mietvertrags in <strong>{{getLeaseMainAddress lease}}</strong> wird ab dem <strong>{{formatDate leasePriceHistory.applicationDate}}</strong> angepasst.</p>
        <p>Wir ändern Ihren gesamten {{getLeasePaymentFrequency lease}} Preis von {{getTotalPreviousPriceForFrequency lease leasePriceHistory}} € auf <strong>{{getTotalFuturePriceForFrequency lease leasePriceHistory}}</strong> €.</p>
        <p></p>
        {{#if (hasComment leasePriceHistory)}}
        <p>Kommentar:</p>
        <i>{{leasePriceHistory.comment}}</i>
        <p></p>
        {{/if}}
        <p>Vielen Dank, dass Sie dies berücksichtigen und den periodischen Betrag Ihrer Lastschrift anpassen.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
